var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_c('div',{staticClass:"mb-5"},[_c('a-skeleton',{attrs:{"active":""}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',{staticClass:"mb-3"},[_c('strong',[_vm._v("Basic")])])}]

export { render, staticRenderFns }